import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import SendcloudReturnsCredentialsStore
    from '../../../../stores/credentials/shipping/sendcloud-returns-credentials-store';
import ApiSecretField from '../fields/api-secret-field/api-secret-field';

interface IProps {
    credentialsStore: SendcloudReturnsCredentialsStore,
    vGroup: IValidationGroup,
}

const SendcloudReturnsCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <FormFieldLine
                required
                label='Brand ID'
                key='brand_id'
                note={'Sendcloud brand ID available in dashboard settings URL'}
            >
                <Input
                    value={credentialsStore.brandId}
                    onChange={credentialsStore.setBrandId}
                    validationGroup={vGroup}
                    type='password'
                    autoComplete='new-password'
                    required
                />
            </FormFieldLine>
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Sendcloud public key'
                note='Sendcloud API key available in dashboard integration settings'
            />
            <ApiSecretField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Sendcloud secret key'
                note='Sendcloud API secret available in dashboard integration settings'
            />
        </>
    );
});

export default SendcloudReturnsCredentials;
